/**
 * Limits and vocabulary shared by the API boundary and the browser forms, so a
 * value can never be accepted by one and silently rejected by the other.
 */

export const RESUME_MAX_BYTES = 10 * 1024 * 1024; // 10 MB

export const RESUME_ALLOWED_EXTENSIONS = ['.pdf', '.doc', '.docx'] as const;

export const RESUME_ALLOWED_MIME_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
] as const;

/** `accept` attribute for the resume file input. */
export const RESUME_ACCEPT_ATTRIBUTE = [...RESUME_ALLOWED_EXTENSIONS, ...RESUME_ALLOWED_MIME_TYPES].join(',');

export const FIELD_LIMITS = {
  name: 100,
  email: 254,
  phone: 40,
  location: 160,
  url: 2048,
  coverLetter: 20_000,
  jobTitle: 160,
  jobDepartment: 120,
  jobLocation: 160,
  jobSlug: 120,
  jobSummary: 400,
  jobLongText: 20_000,
  questionLabel: 300,
  questionHelpText: 500,
  questionChoice: 200,
  shortTextAnswer: 500,
  longTextAnswer: 10_000,
  noteBody: 10_000,
  contactCompany: 160,
  contactMessage: 10_000,
  password: 200,
} as const;

export const MAX_QUESTIONS_PER_JOB = 25;
export const MAX_CHOICES_PER_QUESTION = 30;

export const APPLICATION_PAGE_SIZE_DEFAULT = 25;
export const APPLICATION_PAGE_SIZE_MAX = 100;
/** The candidates spreadsheet loads everything at once, up to this many rows. */
export const APPLICATION_GRID_ROW_LIMIT = 5000;
/** Characters of a cover letter or note shown in a spreadsheet cell. */
export const APPLICATION_GRID_PREVIEW_LENGTH = 280;
export const CONTACT_MESSAGE_PAGE_SIZE_DEFAULT = 25;
export const CONTACT_MESSAGE_PAGE_SIZE_MAX = 100;

/** Public application reference: opaque, non-sequential, easy to read aloud. */
export const APPLICATION_REFERENCE_PREFIX = 'ABS';
export const APPLICATION_REFERENCE_PATTERN = /^ABS-[0-9A-HJ-NP-TV-Z]{4}-[0-9A-HJ-NP-TV-Z]{4}$/;
export const CONTACT_REFERENCE_PREFIX = 'MSG';

/** Warning shown next to the custom-question builder in the admin UI. */
export const QUESTION_LAWFULNESS_WARNING =
  'Only ask for information that is relevant, lawful, and necessary for evaluating this role.';

export const IDEMPOTENCY_KEY_HEADER = 'x-idempotency-key';
export const CSRF_TOKEN_HEADER = 'x-csrf-token';

/** Hidden field that real candidates never fill in. */
export const HONEYPOT_FIELD_NAME = 'company_website';
